module.exports = __webpack_public_path__ + "img/ico-play.30322170.svg";